<template>
  <v-card>
    <s-toolbar label="Subir Firmas" dark color="#8e8f91"></s-toolbar>
    <v-container>
      <v-row>
        <v-col cols="12" lg="4" align="center">
          <!-- <v-file-input label="Seleccione una imagen" @change="handleFileUpload"></v-file-input> -->
          <input type="file" @change="handleFileUpload">
        </v-col>
        <v-col cols="12" lg="3">
            <s-text uppercase label="Apellidos y Nombres" v-model="nameFile"></s-text>
        </v-col>
        <v-col cols="12" lg="3" align="center">
          <v-text-field :label="`Umbral: ${threshold}`" v-model="threshold" type="range" min="0" max="255"></v-text-field>
        </v-col>
        <v-col cols="12" lg="2" align="center">
          <v-btn color="primary" small @click="applyThreshold">Aplicar</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center">
          <canvas ref="canvas" width="600" height="300"
                  @mousedown="startDrawing"
                  @mousemove="draw"
                  @mouseup="stopDrawing"
                  @mouseleave="stopDrawing"></canvas>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" align="center">
          <v-btn block color="success" @click="saveImage"><v-icon left>mdi-content-save</v-icon> Guardar en Servidor</v-btn>
        </v-col>
        <v-col cols="12" md="6" align="center">
          <v-btn block color="info" outlined @click="downloadLocalImage"><v-icon left>mdi-download</v-icon> Descargar JPG Local</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import GenUploadFiles from '@/services/General/GenUploadFiles';
export default {
  data() {
    return {
      img: null,
      threshold: 150,
      isDrawing: false,
      nameFile: "",
      genParameter: "routeSignatures",
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          this.img = img;
          this.applyThreshold(); // Procesar al cargar
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    applyThreshold() {
      if (!this.img) return;

      const scaleFactor = 2;
      const tempCanvas = document.createElement('canvas');
      const tempCtx = tempCanvas.getContext('2d');

      tempCanvas.width = this.img.width * scaleFactor;
      tempCanvas.height = this.img.height * scaleFactor;
      tempCtx.drawImage(this.img, 0, 0, tempCanvas.width, tempCanvas.height);

      const imageData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
        const value = avg > this.threshold ? 255 : 0;
        data[i] = data[i + 1] = data[i + 2] = value;

        // Fondo blanco transparente
        if (value === 255) {
          data[i + 3] = 0;
        }
      }

      tempCtx.putImageData(imageData, 0, 0);

      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Escalado centrado
      const scaleW = canvas.width / tempCanvas.width;
      const scaleH = canvas.height / tempCanvas.height;
      const scale = Math.min(scaleW, scaleH);
      const offsetX = (canvas.width - tempCanvas.width * scale) / 2;
      const offsetY = (canvas.height - tempCanvas.height * scale) / 2;

      ctx.globalCompositeOperation = 'source-over';
      ctx.drawImage(tempCanvas, 0, 0, tempCanvas.width, tempCanvas.height,
                    offsetX, offsetY, tempCanvas.width * scale, tempCanvas.height * scale);
    },

    startDrawing(event) {
      this.isDrawing = true;
      const ctx = this.$refs.canvas.getContext('2d');
      ctx.lineWidth = 15;
      ctx.lineCap = 'round';
      ctx.strokeStyle = 'rgba(0,0,0,1)';
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.moveTo(event.offsetX, event.offsetY);
    },

    draw(event) {
      if (!this.isDrawing) return;
      const ctx = this.$refs.canvas.getContext('2d');
      ctx.lineTo(event.offsetX, event.offsetY);
      ctx.stroke();
    },

    stopDrawing() {
      this.isDrawing = false;
    },

    getProcessedImageBase64() {
      const originalCanvas = this.$refs.canvas;
      const ctx = originalCanvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, originalCanvas.width, originalCanvas.height);
      const data = imageData.data;

      // Buscar el bounding box del contenido visible
      let top = originalCanvas.height, bottom = 0, left = originalCanvas.width, right = 0;

      for (let y = 0; y < originalCanvas.height; y++) {
        for (let x = 0; x < originalCanvas.width; x++) {
          const index = (y * originalCanvas.width + x) * 4;
          const alpha = data[index + 3];
          if (alpha > 0) {
            if (x < left) left = x;
            if (x > right) right = x;
            if (y < top) top = y;
            if (y > bottom) bottom = y;
          }
        }
      }

      const croppedWidth = right - left + 1;
      const croppedHeight = bottom - top + 1;

      if (croppedWidth <= 0 || croppedHeight <= 0) {
        this.$fun.alert('No se detectó contenido válido en la firma', 'warning');
        return null;
      }

      // Crear canvas con la firma recortada
      const croppedCanvas = document.createElement('canvas');
      const croppedCtx = croppedCanvas.getContext('2d');
      croppedCanvas.width = croppedWidth;
      croppedCanvas.height = croppedHeight;
      croppedCtx.drawImage(originalCanvas, left, top, croppedWidth, croppedHeight, 0, 0, croppedWidth, croppedHeight);

      // Calcular escalado, máximo de ancho 185px
      const maxWidth = 185;
      const maxHeight = 148; // Alto máximo conservador u opcional
      let finalWidth = croppedWidth;
      let finalHeight = croppedHeight;

      if (finalWidth > maxWidth || finalHeight > maxHeight) {
        const ratioW = maxWidth / croppedWidth;
        const ratioH = maxHeight / croppedHeight;
        const ratio = Math.min(ratioW, ratioH);
        finalWidth = croppedWidth * ratio;
        finalHeight = croppedHeight * ratio;
      }

      // Crear canvas final con fondo BLANCO
      const finalCanvas = document.createElement('canvas');
      const finalCtx = finalCanvas.getContext('2d');
      finalCanvas.width = finalWidth;
      finalCanvas.height = finalHeight;

      // FONDO BLANCO para evitar que el JPG salga transparente=negro
      finalCtx.fillStyle = "#ffffff";
      finalCtx.fillRect(0, 0, finalWidth, finalHeight);

      // Dibujar la firma encima
      finalCtx.drawImage(croppedCanvas, 0, 0, croppedWidth, croppedHeight,
                        0, 0, finalWidth, finalHeight);

      // Exportar como JPG a la máxima calidad
      // Importante usar image/jpeg para compatibilidad del servidor
      return finalCanvas.toDataURL('image/jpeg', 1.0);
    },

    saveImage() {
      const image = this.getProcessedImageBase64();
      if (!image) return;

      if(!this.nameFile || this.nameFile == ''){
          this.$fun.alert('Falta el nombre de la firma', 'warning');
          return;
      }

      this.$fun.alertFull('Seguro de guardar la firma', 'question').then((r) => {
        if (r.value) {
            GenUploadFiles.upload(image, this.nameFile, this.genParameter, this.$fun.getUserID())
            .then(() => {
                this.$fun.alert("Archivo Guardado Correctamente", "success");
            })
            .catch((error) => {
                if (error.response && error.response.status === 409 && error.response.data.needsConfirmation) {
                    this.$fun.alert("El archivo con el mismo nombre ya existe. ¿Quieres reemplazarlo?", "question").then((val) => {
                        if (val.value) {
                            GenUploadFiles.upload(image, this.nameFile, this.genParameter, this.$fun.getUserID(), true)
                            .then(() => {
                                this.$fun.alert("Archivo reemplazado correctamente", "success");
                            })
                            .catch((err) => {
                                this.$fun.alert("Error al reemplazar el archivo", "warning");
                                console.error("Error al reemplazar el archivo", err);
                            });
                        }
                    });
                } else {
                    this.$fun.alert("Error al subir el archivo", "warning");
                    console.error("Error al subir el archivo", error);
                }
            });
        }
      });
    },

    downloadLocalImage() {
      const image = this.getProcessedImageBase64();
      if (!image) return;

      const fileName = this.nameFile ? `${this.nameFile}.jpg` : 'firma-editada.jpg';
      const link = document.createElement('a');
      link.href = image;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
canvas {
  border: 1px solid #ccc;
  margin-top: 10px;
  cursor: crosshair;
}
</style>